import template from './mapFilterAddPage.html';
import controller from './mapFilterAddPage.controller';
import './mapFilterAddPage.scss';

let mapFilterAddPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mapFilterAddPageComponent;
